
export default function GenericSearchResults({searchTerm, searchResults, total = null , limit}) {
  return (
    <>
      <div className={"search-results__wrapper"}>
        {(searchResults || []).length > 0 &&
          <ul className="search-results__list">
            {(searchResults || []).slice(0, limit).map((result, index) =>
              <li className={"search-result paragraph-faq__item search-result--" + result.bundle.system} key={index}>
                <div className={"expandable-field expandable-field--collapsed"}>
                  <a href="#" className="expandable-field__toggler" aria-expanded="false">
                    <h3>{result.title}</h3>
                    <div className={"expandable-field__toggle-icon"}>
                      <span className={"icon-plus"}></span>
                    </div>
                  </a>
                  <div
                    className={"expandable-field__body expandable-field__toggle-target"}
                    style={{display: "none"}}
                    aria-hidden="true"
                    dangerouslySetInnerHTML={{__html: result.faq_answer || ''}}
                  >
                  </div>
                </div>
              </li>


          )}
      </ul>
      }
    </div>
</>
)
  ;
}
